//Librerias
import * as THREE from "three";
//Proyecto
import Maqueta from "../../../Maqueta.js";

export default class Materiales {
  constructor() {
    this.maqueta = new Maqueta();
    this.escena = this.maqueta.escena;
    this.colores = this.maqueta.colores;
    this.recursos = this.maqueta.recursos;
    this.debug = this.maqueta.debug;

    this.materialesProyecto = {};
    this.materialesContexto = {};
    this.materialesPersonas = [];
    this.materialesArbustos = [];
    this.materialesArboles = [];
    this.materialesArbolesRelleno = [];

    this.recursos.on("cargado", () => {
      this.crearMateriales();
    });

    //Debug
    if (this.debug.active) {
      this.debugMateriales = this.debug.ui.addFolder("Materiales");
    }
  }
  crearMateriales() {
    //******************
    //Materiales proyecto
    //******************

    this.materialesProyecto.text_torreDeshabilitada =
      new THREE.MeshStandardMaterial({
        color: this.colores.coloresMundo.colorEdificios,
        transparent: false,
        //opacity: 0.8,
      });

    //Vecinos
    this.materialesProyecto.edificiosVecinos = new THREE.MeshStandardMaterial({
      color: this.colores.coloresMundo.colorEdificios,
      transparent: true,
      opacity: 0.5,
    });
    this.materialesProyecto.volumen = new THREE.MeshStandardMaterial({
      color: this.colores.coloresMundo.colorEdificios
    });

    //Vidrio
    this.materialesProyecto.vidrio= new THREE.MeshStandardMaterial({
      transparent: true,
      opacity: 0.5,
      color: '#808080'
    });

    //Barandas


    this.materialesProyecto.torre_4_baranda = new THREE.MeshStandardMaterial({
      map: this.recursos.items.text_torre_4_baranda,
      transparent: true,
      opacity: 0.5,
      side: THREE.DoubleSide
    });
    //Mascaras
    this.materialesProyecto.mascaras = new THREE.MeshBasicMaterial({
      color: this.colores.mascaras.mascara1,
      transparent: true,
      opacity: .5
    })
    this.materialesProyecto.mascarasVendido = new THREE.MeshBasicMaterial({
      color: this.colores.mascaras.mascara2,
      transparent: true,
      opacity: .5
    })
    this.materialesProyecto.mascarasOpcionado = new THREE.MeshBasicMaterial({
      color: this.colores.mascaras.mascara3,
      transparent: true,
      opacity: .5
    })
    this.materialesProyecto.mascaraHover = new THREE.MeshBasicMaterial({
      color: this.colores.mascaras.mascaraHover,
      transparent: true,
      opacity: .5
    })
    this.materialesProyecto.mascaraClick = new THREE.MeshBasicMaterial({
      color: this.colores.mascaras.mascaraClick
    })

    this.materialesProyecto.zonasSeleccionadas = new THREE.MeshStandardMaterial({
      color: this.colores.paleta.color6
    })
    this.materialesProyecto.pisoSeleccionado = new THREE.MeshStandardMaterial({
      color: this.colores.paleta.color6
    })
    this.materialesProyecto.mascarasZonas = new THREE.MeshBasicMaterial({
      color: this.colores.mascaras.mascara3,
      transparent: true,
      opacity: .5,
      side: THREE.DoubleSide
    })

    //******************
    //Materiales contexto
    //******************

    //Nubes

    //Satelital
    const texturaSatelital = this.recursos.items.textura_satelital;
    this.materialesContexto.satelital = new THREE.MeshStandardMaterial({
      map: texturaSatelital,
      side: THREE.DoubleSide,
    });
    /*const texturaSatelitalZoom = this.recursos.items.textura_satelital_zoom;
    this.materialesContexto.satelitalZoom = new THREE.MeshStandardMaterial({
      map: texturaSatelitalZoom,
      side: THREE.DoubleSide,
    });*/
    //Elevacion
    this.materialesContexto.elevacion = new THREE.MeshStandardMaterial({
      displacementMap: this.recursos.items.textura_terreno_elevacion,
      displacementScale: 12,
      color: this.colores.coloresMundo.colorTerreno,
    });

    //Pasto base
    this.materialesContexto.pastoBase = new THREE.MeshStandardMaterial({
      color: this.colores.paleta.color6
    })

    //Vias
    this.materialesContexto.vias = new THREE.MeshStandardMaterial({
      color: this.colores.coloresMundo.colorVias,
      transparent: true,
      opacity: .75,
      side: THREE.DoubleSide
    })
    //Arbustos

    const materialArbusto_tipo1 = new THREE.SpriteMaterial();
    materialArbusto_tipo1.map = this.recursos.items.textura_arbusto_tipo1;
    materialArbusto_tipo1.alphaMap =
      this.recursos.items.textura_arbusto_tipo1_alpha;
    materialArbusto_tipo1.transparent = true;
    materialArbusto_tipo1.alphaTest = 0.001;

    const materialArbusto_tipo2 = new THREE.SpriteMaterial();
    materialArbusto_tipo2.map = this.recursos.items.textura_arbusto_tipo2;
    materialArbusto_tipo2.alphaMap =
      this.recursos.items.textura_arbusto_tipo2_alpha;
    materialArbusto_tipo2.transparent = true;
    materialArbusto_tipo2.alphaTest = 0.001;

    const materialArbusto_tipo3 = new THREE.SpriteMaterial();
    materialArbusto_tipo3.map = this.recursos.items.textura_arbusto_tipo3;
    materialArbusto_tipo3.alphaMap =
      this.recursos.items.textura_arbusto_tipo3_alpha;
    materialArbusto_tipo3.transparent = true;
    materialArbusto_tipo3.alphaTest = 0.001;

    this.materialesArbustos.push(
      materialArbusto_tipo1,
      materialArbusto_tipo2,
      materialArbusto_tipo3
    );
    //Arboles

    const materialArbol_tipo1 = new THREE.SpriteMaterial();
    materialArbol_tipo1.map = this.recursos.items.textura_arbol_tipo1;
    materialArbol_tipo1.alphaMap =
      this.recursos.items.textura_arbol_tipo1_alpha;
    materialArbol_tipo1.transparent = true;
    materialArbol_tipo1.alphaTest = 0.1;

    const materialArbol_tipo2 = new THREE.SpriteMaterial();
    materialArbol_tipo2.map = this.recursos.items.textura_arbol_tipo2;
    materialArbol_tipo2.alphaMap =
      this.recursos.items.textura_arbol_tipo2_alpha;
    materialArbol_tipo2.transparent = true;
    materialArbol_tipo2.alphaTest = 0.1;

    const materialArbol_tipo3 = new THREE.SpriteMaterial();
    materialArbol_tipo3.map = this.recursos.items.textura_arbol_tipo3;
    materialArbol_tipo3.alphaMap =
      this.recursos.items.textura_arbol_tipo3_alpha;
    materialArbol_tipo3.transparent = true;
    materialArbol_tipo3.alphaTest = 0.1;

    const materialArbol_tipo4 = new THREE.SpriteMaterial();
    materialArbol_tipo4.map = this.recursos.items.textura_arbol_tipo4;
    materialArbol_tipo4.alphaMap =
      this.recursos.items.textura_arbol_tipo4_alpha;
    materialArbol_tipo4.transparent = true;
    materialArbol_tipo4.alphaTest = 0.1;

    this.materialesArboles.push(
      materialArbol_tipo1,
      materialArbol_tipo2,
      materialArbol_tipo3,
      materialArbol_tipo4
    );

    //Arboles Relleno

    const materialArbolRelleno_tipo1 = new THREE.SpriteMaterial();
    materialArbolRelleno_tipo1.map = this.recursos.items.textura_arboles_tipo1;
    materialArbolRelleno_tipo1.alphaMap =
      this.recursos.items.textura_arboles_tipo1_alpha;
    materialArbolRelleno_tipo1.transparent = true;
    materialArbolRelleno_tipo1.alphaTest = 0.001;

    const materialArbolRelleno_tipo2 = new THREE.SpriteMaterial();
    materialArbolRelleno_tipo2.map = this.recursos.items.textura_arboles_tipo2;
    materialArbolRelleno_tipo2.alphaMap =
      this.recursos.items.textura_arboles_tipo2_alpha;
    materialArbolRelleno_tipo2.transparent = true;
    materialArbolRelleno_tipo2.alphaTest = 0.001;

    const materialArbolRelleno_tipo3 = new THREE.SpriteMaterial();
    materialArbolRelleno_tipo3.map = this.recursos.items.textura_arboles_tipo3;
    materialArbolRelleno_tipo3.alphaMap =
      this.recursos.items.textura_arboles_tipo3_alpha;
    materialArbolRelleno_tipo3.transparent = true;
    materialArbolRelleno_tipo3.alphaTest = 0.001;

    this.materialesArbolesRelleno.push(
      materialArbolRelleno_tipo1,
      materialArbolRelleno_tipo2,
      materialArbolRelleno_tipo3,
      materialArbol_tipo4
    );

    //Personas
    const materialPersona_tipo1 = new THREE.SpriteMaterial();
    //materialPersona_tipo1.map = this.recursos.items.textura_personas_tipo1;
    materialPersona_tipo1.alphaMap =
      this.recursos.items.textura_personas_tipo1_alpha;
    materialPersona_tipo1.transparent = true;
    materialPersona_tipo1.alphaTest = 0.001;

    const materialPersona_tipo2 = new THREE.SpriteMaterial();
    //materialPersona_tipo2.map = this.recursos.items.textura_personas_tipo2;
    materialPersona_tipo2.alphaMap =
      this.recursos.items.textura_personas_tipo2_alpha;
    materialPersona_tipo2.transparent = true;
    materialPersona_tipo2.alphaTest = 0.001;

    const materialPersona_tipo3 = new THREE.SpriteMaterial();
    //materialPersona_tipo3.map = this.recursos.items.textura_personas_tipo3;
    materialPersona_tipo3.alphaMap =
      this.recursos.items.textura_personas_tipo3_alpha;
    materialPersona_tipo3.transparent = true;
    materialPersona_tipo3.alphaTest = 0.001;

    const materialPersona_tipo4 = new THREE.SpriteMaterial();
    //materialPersona_tipo4.map = this.recursos.items.textura_personas_tipo4;
    materialPersona_tipo4.alphaMap =
      this.recursos.items.textura_personas_tipo4_alpha;
    materialPersona_tipo4.transparent = true;
    materialPersona_tipo4.alphaTest = 0.001;

    const materialPersona_tipo5 = new THREE.SpriteMaterial();
    //materialPersona_tipo5.map = this.recursos.items.textura_personas_tipo5;
    materialPersona_tipo5.alphaMap =
      this.recursos.items.textura_personas_tipo5_alpha;
    materialPersona_tipo5.transparent = true;
    materialPersona_tipo5.alphaTest = 0.001;

    this.materialesPersonas.push(
      materialPersona_tipo1,
      materialPersona_tipo2,
      materialPersona_tipo3,
      materialPersona_tipo4,
      materialPersona_tipo5
    );
  }
}
